import React, { useEffect, useState } from "react";
import Card from "../components/Card/Card";
import InputGroup from "../components/Filter/category/InputGroup";

const Episodes = () => {
  let [results, setResults] = React.useState([]);
  let [info, setInfo] = useState([]);
  let { air_date, episode, name } = info;
  let [id, setID] = useState(1);

  let api = `https://rickandmortyapi.com/api/episode/${id}`;

  useEffect(() => {
    (async function () {
      let data = await fetch(api).then((res) => res.json());
      setInfo(data);

      let a = await Promise.all(
        data.characters.map((x) => {
          return fetch(x).then((res) => res.json());
        })
      );
      setResults(a);
    })();
  }, [api]);

 function FormataData(dataInfo){
  let dataInformada = new Date(dataInfo);
  return dataInformada.toLocaleString("pt-BR",{year: 'numeric',
  month: '2-digit',
  day: '2-digit'})

}

  return (

    <div className="container">
      <div className="row mb-3">
        <h1 className="text-center mb-3">
          Episódio {id}:{" "}
          <span className="text-primary">{name === "" ? "Desconhecido" : name}</span>
        </h1>
        <h5 className="text-center">
          No ar em: {air_date === "" ? "Desconhecido" : FormataData(air_date)}
        </h5>
      </div>
      <div className="row">
        <div className="col-lg-3 col-12 mb-4">
          <h4 className="text-center mb-4">Episódios</h4>
          <InputGroup name="Episode" changeID={setID} total={51} />
        </div>
        <div className="col-lg-8 col-12">
          <div className="row">
            <Card page="/episodes/" results={results} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Episodes;